import { nl } from "date-fns/locale"
import { format } from "date-fns"

export function formatNumber(value, precision) {
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: "decimal",
    ...(precision !== null && {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    }),
  })
  return formatter.format(value)
}

export function formatCurrency(value, currency, precision) {
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: currency ?? "EUR",
    minimumFractionDigits: precision ?? 2,
    maximumFractionDigits: precision ?? 2,
  })
  return formatter.format(value)
}

const prefixes = [
  { value: 1e15, symbol: "P" },
  { value: 1e12, symbol: "T" },
  { value: 1e9, symbol: "G" },
  { value: 1e6, symbol: "M" },
  { value: 1e3, symbol: "k" },
]

export function scaleWithUnit(value, unit, minPrefix) {
  let scale = 1
  let symbol = unit
  const prefix = prefixes.find(
    (p) => Math.abs(value) >= p.value * 10 || p.symbol === minPrefix,
  )
  if (prefix) {
    scale /= prefix.value
    symbol = prefix.symbol + unit
  }
  return [scale, symbol]
}

export function formatUnit(value, unit, precision = null, minPrefix) {
  const [scale, symbol] = scaleWithUnit(value, unit, minPrefix)
  // Formatted with a 'non-breaking space' character U+00A0
  return `${formatNumber(value * scale, precision)}\u00A0${symbol}`
}

export function formatKW(value, unit = "W", precision = null) {
  return formatUnit(value * 1000, unit, precision, "k")
}

export function formatBoolean(value) {
  return value ? "Ja" : "Nee"
}

export function formatPercentage(value, precision) {
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: "percent",
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
  return formatter.format(value)
}

export function padNumber(number, length) {
  return number.toString().padStart(length, "0")
}

export function formatDate(date) {
  return format(date, "d MMM yyyy", { locale: nl })
}

export function formatDateTime(date) {
  return format(date, "d MMM yyyy, H:mm", { locale: nl })
}

export function formatDateRange(value) {
  const from = formatDate(value[0])
  const to = formatDate(value[1])
  if (from === to) {
    return from
  }
  return `${from} - ${to}`
}
